import { PATH_NAMES } from '../constants';

export const config = {
  shopsNextPath: PATH_NAMES.SELECT_DATE,
  selectDatePrevPath: PATH_NAMES.SELECT_SHOP,
  aboutYouPrevPath: PATH_NAMES.SELECT_DATE,
  reviewPrevPath: PATH_NAMES.ABOUT_YOU,

  editShopNextPath: PATH_NAMES.EDIT_DATE,
  editDatePrevPath: PATH_NAMES.EDIT_SHOP,
};
